import client from './client';

export interface OrgTool {
  id: string;
  name: string;
  displayName: string | null;
  description: string;
  inputSchema: Record<string, unknown>;
  kind: string;
  config: Record<string, unknown>;
  timeoutMs: number;
  enabled: boolean;
  hasSecret: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateOrgToolPayload {
  name: string;
  description: string;
  inputSchema: Record<string, unknown>;
  kind: string;
  config: Record<string, unknown>;
  timeoutMs?: number;
  enabled?: boolean;
  secret?: Record<string, unknown>;
}

export type UpdateOrgToolPayload = Omit<CreateOrgToolPayload, 'name'>;

export interface TestOrgToolPayload {
  kind: string;
  config: Record<string, unknown>;
  inputSchema?: Record<string, unknown>;
  timeoutMs?: number;
  secret?: Record<string, unknown>;
  toolId?: string;
}

export interface OrgToolTestResult {
  ok: boolean;
  statusCode: number | null;
  message: string;
  latencyMs: number;
}

export async function listOrgTools(): Promise<OrgTool[]> {
  const response = await client.get('/api/v1/org-tools');
  return response.data;
}

export async function createOrgTool(payload: CreateOrgToolPayload): Promise<OrgTool> {
  const response = await client.post('/api/v1/org-tools', payload);
  return response.data;
}

export async function updateOrgTool(
  toolId: string,
  payload: UpdateOrgToolPayload,
): Promise<OrgTool> {
  const response = await client.put(`/api/v1/org-tools/${toolId}`, payload);
  return response.data;
}

export async function deleteOrgTool(toolId: string): Promise<void> {
  await client.delete(`/api/v1/org-tools/${toolId}`);
}

export async function testOrgTool(
  payload: TestOrgToolPayload,
): Promise<OrgToolTestResult> {
  const response = await client.post('/api/v1/org-tools/test', payload);
  return response.data;
}
